// extracted by mini-css-extract-plugin
export var actions = "_cv-d";
export var benefitCard = "_cv-a";
export var benefitIcon = "_cv-b";
export var benefitLabel = "_cv-c";
export var benefits = "_cv-9";
export var bodyText = "_cv-8";
export var closeButton = "_cv-2";
export var content = "_cv-3";
export var eyebrow = "_cv-4";
export var heading = "_cv-5";
export var image = "_cv-f";
export var imagePanel = "_cv-e";
export var modal = "_cv-0";
export var shell = "_cv-1";
export var title = "_cv-6";
export var titleOffer = "_cv-7";